import React from 'react'
import CommonMomentAndAttendance from '../commonfile/CommonMomentAndAttendance'

const AdminMomentAttendance = () => {
  return (
 <CommonMomentAndAttendance/>
  )
}

export default AdminMomentAttendance